<template>
  <div style="width: 100%; height: 100%" class="d-flex flex-column">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center mb-16"
      style="height: 100vh"
    >
      <v-progress-circular
        indeterminate
        color="secondary"
        size="60"
        style="margin-bottom: 200px"
      >
      </v-progress-circular>
    </div>

    <l-map
      ref="map"
      class="map_style"
      style="width: 100%; z-index: 0"
      :zoom="zoom"
      :center="
        pois.length > 0
          ? [parseFloat(pois[0].latitude), parseFloat(pois[0].longitude)]
          : [39.0742, 21.8243]
      "
      :options="{ zoomControl: false, maxZoom: 18 }"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
        :detectRetina="true"
        :options="{ maxNativeZoom: 18, maxZoom: 18 }"
      ></l-tile-layer>
      <l-control-zoom position="topright"></l-control-zoom>

      <l-control position="topleft" class="d-flex flex-column align-start">
        <div
          class="primary rounded-pill px-2 d-flex align-center"
          @click="
            $route.path.split('/')[4] == 'map'
              ? $router.push(`/islands/area/${currentArea.id}`)
              : $router.push(`/islands/area/${currentArea.id}/pois`)
          "
        >
          <v-btn icon v-if="$route.path.split('/')[1] != 'pois'">
            <v-icon color="white" size="17">mdi-arrow-left</v-icon>
          </v-btn>
          <span
            v-if="$route.path.split('/')[1] != 'pois'"
            class="body-2 white--text pr-1"
            >{{
              $route.path.split("/")[4] == "map"
                ? currentArea.name
                : $t("pois.title")
            }}</span
          >
        </div>
        <div
          class="secondary rounded-pill px-2 d-flex align-center"
          @click="$router.push(`/pois/results`)"
        >
          <v-btn icon v-if="$route.path.split('/')[1] == 'pois'">
            <v-icon color="white" size="17">mdi-arrow-left</v-icon>
          </v-btn>
          <span
            v-if="$route.path.split('/')[1] == 'pois'"
            class="body-2 white--text pr-1"
            >{{ $t("pois.title") }}</span
          >
        </div>

        <v-chip
          @click:close="
            onSubareaSelect();
            subarea = null;
          "
          v-if="subarea != null"
          close
          close-icon="mdi-close"
          color="white"
          class="mt-2 primary--text"
        >
          {{ subareaCategory(subarea).name }}
        </v-chip>
      </l-control>

      <v-marker-cluster
        :options="{
          disableClusteringAtZoom: 18,
          spiderfyOnMaxZoom: false,
          showCoverageOnHover: false,
          // zoomToBoundsOnClick: false,
        }"
      >
        <div v-for="(poi, i) in pois" :key="i">
          <l-marker
            v-if="poi.category_id != 23"
            @click="openDialog(poi)"
            :lat-lng="[parseFloat(poi.latitude), parseFloat(poi.longitude)]"
            :draggable="false"
            :zIndexOffset="-1"
          >
            <l-tooltip v-if="pois.length == 1" :options="{ permanent: true }">
              {{ poi.name }}
            </l-tooltip>
          </l-marker>
          <l-marker
            v-if="poi.category_id == 23"
            @click="openGoogleMaps(poi)"
            :lat-lng="[parseFloat(poi.latitude), parseFloat(poi.longitude)]"
            :draggable="false"
            :zIndexOffset="-1"
          >
            <l-icon
              :icon-size="[41, 41]"
              icon-url="/parking-pin.svg"
              className="filter-blue"
            >
            </l-icon>
          </l-marker>
        </div>
      </v-marker-cluster>

      <custom-marker
        :marker="{ lat: location.latitude, lng: location.longitude }"
      >
        <v-icon color="secondary" class="rounded-circle pulse-button" size="15"
          >mdi-circle</v-icon
        >
      </custom-marker>

      <l-control position="bottomright">
        <v-bottom-sheet
          v-model="sheet"
          inset
          scrollable
          v-if="$route.path.split('/')[4] != 'pois'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="white" fab dark medium>
              <v-icon size="30" color="secondary" v-bind="attrs" v-on="on"
                >mdi-tune</v-icon
              >
            </v-btn>
          </template>

          <v-card color="white" height="auto" class="px-6 pb-16">
            <div class="text-h5 font-weight-bold pt-6">
              {{ $t("menu.areas") }}
            </div>
            <v-divider class="my-4"></v-divider>
            <div
              v-for="(area, i) in subareas"
              :key="i + area.id"
              @click="onSubareaSelect(area)"
              class="mb-4"
            >
              <span
                :class="
                  subarea && subarea.id == area.id
                    ? 'font-weight-bold'
                    : 'font-weight-regular'
                "
                class="body-1 d-flex align-center"
              >
                <span class="mr-auto">
                  {{ area.name }}
                </span>
                <img
                  v-if="subarea && subarea.id == area.id"
                  class="check-icon"
                  src="@/assets/icons/check.png"
                />
              </span>
            </div>
          </v-card>
        </v-bottom-sheet>

        <div class="d-flex flex-column align-center mt-2">
          <v-btn
            icon
            class="primary mb-2 white--text"
            @click="getLocation(true)"
            :loading="locationLoader"
          >
            <v-icon color="white">mdi-crosshairs-gps</v-icon>
          </v-btn>
        </div>
      </l-control>
    </l-map>

    <v-dialog
      persistent
      v-model="dialog.open"
      max-width="100%"
      fullscreen
      style="z-index: 900 !important"
      no-click-animation
    >
      <PoiDialog :poi="dialog.poi" v-if="dialog.open" @close="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import PoiDialog from "../../../components/PoiDialog.vue";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import axios from "axios";
import CustomMarker from "vue-leaflet-custom-marker";
import L from "leaflet";

import {
  LMap,
  LTileLayer,
  LMarker,
  LControl,
  LControlZoom,
  LTooltip,
  LIcon,
} from "vue2-leaflet";

import { Icon } from "leaflet";

import { mapActions, mapState } from "vuex";

// Icon fix
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  components: {
    PoiDialog,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LControlZoom,
    LTooltip,
    LIcon,
    CustomMarker,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },

  async created() {
    try {
      if (this.$route.path.split("/")[4] == "pois") {
        this.step = 2;

        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/pois/${this.$route.params.poi_id}`
        );
        this.pois.push(res.data.poi);
      } else if (this.$route.path.split("/")[1] == "pois") {
        this.step = 2;
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/pois/${this.$route.params.poi_id}`
        );
        this.pois.push(res.data.poi);
      } else {
        this.step = 1;
        const subareas = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subareas`
        );

        const pois = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois`
        );

        this.pois = pois.data;

        this.subareas = subareas.data;
        this.loader = false;
        // const res = await axios.get(
        //   `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/pois`
        // );
        // this.pois = res.data.pois;
      }
      await this.getLocation(false);
      // var markers = L.markerClusterGroup({
      //   disableClusteringAtZoom: 18,
      //   spiderfyOnMaxZoom: false,
      //   showCoverageOnHover: false,
      //   // zoomToBoundsOnClick: false,
      // });
      // for (let i = 0; i < this.pois.length; i++) {
      //   markers.addLayer(
      //     L.marker([this.pois[i].latitude, this.pois[i].longitude])
      //   );
      //   this.map.addLayer(markers);
      // }
      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.map?.mapObject;

      // setTimeout(() => {
      //   this.$refs?.startPageHeight.scrollIntoView();
      // }, 2000);
    });
  },

  data() {
    return {
      locationLoader: false,
      sheet: false,
      subareas: [],
      subarea: null,
      pois: [],
      step: 2,
      map: null,

      loader: true,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 9,

      dialog: {
        open: false,
        poi: null,
      },
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,
      location: (state) => state.base.location,
    }),
  },

  methods: {
    ...mapActions(["getLocation"]),
    openGoogleMaps(poi) {
      window.open(
        `https://www.google.com/maps/dir/?api=1&origin=${this.location.latitude}, ${this.location.longitude}&destination=${poi.latitude}, ${poi.longitude}&travelmode=driving`
      );
    },

    async getLocation(setView) {
      try {
        this.locationLoader = true;
        await this.$store.dispatch("getLocation");
        this.locationLoader = false;
        if (setView) this.setView(this.location);
      } catch (e) {
        console.log(e);
      }
    },

    setView(coords) {
      this.$refs.map.mapObject.setView(
        [coords.latitude, coords.longitude],
        16,
        {
          // animate: true,
          // duration: 1,
        }
      );
    },

    subareaCategory(subarea) {
      return this.subareas.find((el) => el.id == subarea.id);
    },

    async onSubareaSelect(subarea) {
      this.loader = true;
      this.sheet = false;

      if (subarea == undefined) {
        const pois = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois`
        );

        this.pois = pois.data;
        this.subarea = subarea;
        this.loader = false;
        return;
      }
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          area: subarea.id,
        },
      });
      this.pois = res.data;
      this.subarea = subarea;
      this.loader = false;
    },

    openDialog(poi) {
      this.dialog = {
        open: true,
        poi,
      };
    },

    closeDialog() {
      this.dialog = {
        open: false,
        poi: null,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.map_style {
  height: calc(100vh - 154px);
}

.pulse-button {
  -webkit-animation: pulse-location 1.5s infinite;
  box-shadow: 0 0 0 8px rgba(#5a99d4, 0.5);
  border: 0.5px solid white;
}

.pulse-button:hover {
  -webkit-animation: none;
}

.check-icon {
  width: 19px;
  height: 14px;
}

.filter-blue {
  filter: invert(44%) sepia(36%) saturate(1166%) hue-rotate(167deg)
    brightness(96%) contrast(87%);
}
</style>
